import { alpha, keyframes, type SxProps, type Theme } from "@mui/material/styles";

export const root: SxProps<Theme> = {
  minHeight: "100dvh",
  display: "flex",
  flexDirection: "column",
  bgcolor: "background.default",
  color: "text.primary",
};

export const header: SxProps<Theme> = (theme) => ({
  height: 64,
  flex: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  px: { xs: 2, sm: 4 },
  bgcolor: "background.paper",
  borderBottom: 1,
  borderColor: "divider",
  boxShadow: theme.shadows[1],
});

export const headerLogo: SxProps<Theme> = {
  height: 26,
  width: "auto",
  objectFit: "contain",
};

export const main: SxProps<Theme> = {
  flex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  px: { xs: 2, sm: 3 },
  py: { xs: 4, sm: 6 },
};

export const mainInner: SxProps<Theme> = {
  width: "100%",
  maxWidth: 560,
};

export const statusCard: SxProps<Theme> = (theme) => ({
  bgcolor: "background.paper",
  border: 1,
  borderColor: "divider",
  borderRadius: 3,
  boxShadow: theme.shadows[3],
  px: { xs: 2, sm: 3 },
  py: { xs: 6, sm: 7.5 },
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: theme.spacing(1.75),
  textAlign: "center",
});

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const spinner =
  (theme: Theme): SxProps<Theme> =>
  ({
    width: 46,
    height: 46,
    borderRadius: "50%",
    border: `4px solid ${alpha(theme.palette.primary.main, 0.15)}`,
    borderTopColor: theme.palette.primary.main,
    animation: `${spin} 0.8s linear infinite`,
  });

export const statusIconWrap =
  (variant: "success" | "error"): SxProps<Theme> =>
  (theme) => ({
    width: { xs: 72, sm: 84 },
    height: { xs: 72, sm: 84 },
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    mb: 0.75,
    bgcolor:
      variant === "success"
        ? alpha(theme.palette.success.main, 0.1)
        : alpha(theme.palette.error.main, 0.1),
  });

export const statusTitle: SxProps<Theme> = {
  fontWeight: 700,
  fontSize: { xs: "1.03125rem", sm: "1.25rem" },
};

export const statusDescription: SxProps<Theme> = {
  fontSize: "0.8125rem",
  color: "text.secondary",
  lineHeight: 1.8,
  maxWidth: 380,
};

export const actions: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: { xs: "column", sm: "row" },
  alignItems: "center",
  gap: theme.spacing(1.25),
  mt: 1,
  width: { xs: "100%", sm: "auto" },
});

export const redirectHint: SxProps<Theme> = {
  mt: 0.5,
  px: 2,
  py: 1.25,
  borderRadius: 1.75,
  bgcolor: "background.default",
  fontSize: "0.75rem",
  color: "text.secondary",
};
